import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { GetRoomsResponse } from '../modal/room';

export interface GetRoomsParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const getRoomsAPI = async (params?: GetRoomsParams) => {
  const response = await baseAPI.get<GetRoomsResponse>(
    `custom-form/studio/fields`,
    {
      params: {
        ...params,
        type: 'room',
      },
    },
  );
  return response.data;
};

export const getRoomsQueryOptions = (params?: GetRoomsParams) =>
  queryOptions({
    queryKey: [KEYS.ROOMS, params],
    queryFn: () => getRoomsAPI(params),
    placeholderData: keepPreviousData,
  });

export const useGetRooms = (params?: GetRoomsParams) => {
  return useQuery(getRoomsQueryOptions(params));
};
